import type {
	JSX,
} from 'react'
import {
	memo,
} from 'react'

import {
	Loader,
} from '../loader'
import {
	PageLoaderRoot,
	PageLoaderText,
} from './page-loader.styles'
import type {
	IPageLoaderProps,
} from './page-loader.types'

export const PageLoader = memo((props: IPageLoaderProps): JSX.Element => {
	const {
		fullScreen = false,
	} = props

	return (
		<PageLoaderRoot fullScreen={fullScreen}>
			<Loader size='large' />
			<PageLoaderText>Загрузка...</PageLoaderText>
		</PageLoaderRoot>
	)
})

PageLoader.displayName = 'PageLoader'
